import { BrandLogo, type BrandLogoProps } from './BrandLogo.js';

export type BrandMarkProps = Omit<BrandLogoProps, 'variant'>;

export function BrandMark(props: BrandMarkProps): JSX.Element {
  return <BrandLogo {...props} variant="mark" />;
}
